export default "__VITE_ASSET__FWzOHrPa__"